import { UntypedFormControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {
  static validatorOnlyNumber(control: UntypedFormControl): ValidationErrors | null {
    if (/^\d+$/.test(control.value)) {
      return { valueOnlyNumberError: true };
    }
    return null;
  }

  static validatorCurrencyZero(control: UntypedFormControl): ValidationErrors | null {
    if (control.value == "0.00") {
      return { valueZeroError: true };
    }
    return null;
  }

  static validatorNroProcesso(control: UntypedFormControl): ValidationErrors | null {
    const value = control.value;
    if (!value) {
      return { valueEmptyError: true };
    }

    // Verifica se o valor é um número e tem exatamente 20 dígitos
    if (!/^\d{20}$/.test(value)) {
      return { valueFormatError: true };
    }

    const digit14 = parseInt(value.charAt(13), 10);
    const digit15_16 = parseInt(value.substr(14, 2), 10);

    // Verifica o 14º dígito e os valores permitidos para os 15º e 16º dígitos
    switch (digit14) {
      case 4:
        if (digit15_16 < 1 || digit15_16 > 6) {
          return { valueInvalidError: true };
        }
        break;
      case 5:
        if (digit15_16 < 1 || digit15_16 > 24) {
          return { valueInvalidError: true };
        }
        break;
      case 6:
      case 8:
        if (digit15_16 < 1 || digit15_16 > 27) {
          return { valueInvalidError: true };
        }
        break;
      default:
        return { valueInvalidError: true };
    }

    return null;
  }
}
